angular.module('zc.projects')

.controller 'NewImageCtrl', ($scope, $stateParams, Api) ->
  base_url = "/api/projects/#{$stateParams.projectId}"

  $scope.$on 'flow::fileAdded', (event, $flow, flowFile) ->
    event.preventDefault()

    Api.post "#{base_url}/images.json", {},
      method: 'POST'
      headers:
        'Content-Type': undefined
      data:
        image: flowFile.file
      transformRequest: (data) ->
        fd = new FormData()
        # val key order!
        angular.forEach data, (val, key) ->
          fd.append(key, val)
        return fd
    .then ({data}) ->
      $scope.campaign.element.message[$scope.itemName] = data.image.image_url
    .catch (err) ->
      console.error err



// WEBPACK FOOTER //
// ../enterprise/src/zenclerk_modules/projects/controllers/images/new_controller.js.coffee